import { Component } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { Globals } from '../../services/globals';
import { Packet } from '../../models/packet';
import { ImageService } from '../../services/image.service';
import { PacketService } from '../../services/packet.service';
import { ExerciseService } from '../../services/exercise.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ex-chart',
  templateUrl: './ex-chart.html',
  styleUrls: ['./ex-chart.scss'],
})

export class ExChartPage {

  /**
   * 아동 번호
   */
  private bmiNum: number;

  /**
   * 타이틀바 보여줄 값
   */
  titleBarShow: boolean = false;

  /**
   * 운동 리스트
  */
  exList: any[] = [
    { e_name: '거북왕 코얼', e_num: 8, ec_name: '근육발달', ec_num: 8 },
    { e_name: '브레인 러널', e_num: 9, ec_name: '보행교차', ec_num: 8 },
    { e_name: '이글넘벌', e_num: 10, ec_name: '넘버아이', ec_num: 8 },
    { e_name: '캥거루 점핑 패슬', e_num: 11, ec_name: '계획실행', ec_num: 8 },
  ];

  /**
   * 공유 서비스
   */
  ss: SharedService;

  /**
   * 초검&재검 데이터
   */
  testData: any[];

  /**
   * 패킷 정보
   */
  packet: Packet;

  constructor(
    private $imageService: ImageService,
    private $exerciseService: ExerciseService,
    private $packetService: PacketService,
    private $g: Globals,
    private $router: Router) {
    this.ss = SharedService;
    this.viewEnter();
  }

  /**
   * 페이지 진입 시에 운동 리스트 & 차트 데이터 함수 실행, 아동 번호 다를시 변경 처리
   */
  viewEnter() {
    if (this.bmiNum !== this.$g.child.num) {
      this.bmiNum = this.$g.child.num;
    }
    this.getExChartList(this.bmiNum);
    this.getExChartTestData(this.bmiNum);
    this.requestPacket(this.bmiNum);
  }

  /**
   * 비교 버튼 클릭시 타이틀바 변경
   */
  onClickEvent(bl: boolean) {
    this.titleBarShow = bl;
  }

  /**
   * 운동 세부 페이지로 운동 정보 보내줌
   */
  exDetail(ex: Object) {
    this.$router.navigate(['/exercise-detail/' +
      ex['e_num'] + '/' + ex['e_name'] + '/' +
      ex['ec_num'] + '/' + ex['ec_name']]);
  }

  /**
   * 초검&재검 데이터 가져옴
   */
  private getExChartTestData(bmiNum: number) {
    this.$exerciseService.exChartTestData(bmiNum).subscribe(
      (data) => {
        this.testData = data;
      },
      (err) => {
        console.log(err);
      });
  }

  /**
   * 운동 리스트 가져옴
   */
  private getExChartList(bmiNum: number) {
    this.$exerciseService.exChart(bmiNum).subscribe(
      (data) => {
        this.exList = data;
      },
      (err) => {
        console.log(err);
      });
  }

  /**
   * 서버로부터 패킷 정보를 획득하여 출력
   */
  private requestPacket(bmiNum: number) {
    this.$packetService.packet(bmiNum).subscribe(
      (res) => {
        const data = res && res.data;
        if (data) {
          this.packet = new Packet(data);
        }
      },
      () => {
        this.packet = null;
      });
  }

  /**
   * 브레인볼 이미지 서버에서 가져옴
   */
  getBrainBall(ecNum: number, eNum: number): string {
    const eyeCategoryNums = [1, 7, 13];
    const checkupExercise = [67, 73, 79, 84, 89];
    const exerciseNum = eyeCategoryNums.indexOf(ecNum) !== -1 ? 1 :
        checkupExercise.indexOf(eNum) !== -1 ? 67 : eNum;

    return exerciseNum ?
        this.$imageService.exerciseBrainballImage(exerciseNum) : '';
  }

  /**
   * 서버 운동 이미지 주소 요청
   */
  requestExerciseImage(exerciseNumber: number): string {
    return exerciseNumber ? this.$imageService.exerciseImage(exerciseNumber) : '';
  }

  /**
   * 운동 기록과 패킷에 맞는 메세지 출력
   * @return {Array.<Array.<string, string>>} 메세지
   */
  getExerciseMessage() {
    const masseges = [
      ['프로그램 시작 전 입니다.', '프로그램 시작 전 입니다. 잠시만 기다려주세요.'],
      ['운동기록이 없습니다.', '운동기록이 없습니다. 운동 후에  기록을 볼 수 있습니다.'],
      ['프로그램은 일시정지중입니다.', '프로그램은 일시정지중입니다. 프로그램을 시작해주세요.'],
      ['프로그램 등록을 해주세요.', '등록을 원하시면 센터 방문 혹은 센터로 전화 주세요.'],
    ];

    return this.packet && this.packet.status === 0 ?
      masseges[0] : this.packet && this.packet.status === 1 ?
      masseges[1] : this.packet && this.packet.status === 2 ?
      masseges[2] : masseges[3];
  }
}
